<div *ngIf="ViewReady">
    <mat-toolbar color="primary">
        <h2 class="mat-title">{{NomType?.Description}} Judging Form - Nominee # {{JudgingForm?.NominationID}} ({{Phase}})</h2>
    </mat-toolbar>
    <div class="mainpanel">
        <form [formGroup]="RatingForm" (ngSubmit)="SaveRatings(NextSection)" novalidate>
            <div fxLayout="row" fxLayoutAlign="space-between center" class="buttonMargin">
                <button type="button" mat-raised-button color="primary" (click)="Back()"><mat-icon>chevron_left</mat-icon>Back to Nominee List</button>
                <button type="button" mat-raised-button color="warn" *ngIf="ChangesDetected" (click)="SaveRatings(false)"><mat-icon>cloud_upload</mat-icon>Save Ratings</button>
                <button type="button" mat-raised-button color="accent" *ngIf="!ChangesDetected"><mat-icon>cloud_done</mat-icon>Up to Date</button>
            </div>
            <p>You may review the nomination form for this nominee by using the appropriate tabs provided below:</p>
            <div fxLayout="row" fxLayoutAlign="start start" class="tabs">
                <div fxLayout="row" fxLayoutAlign="center end" *ngFor="let sec of JudgingForm?.Sections; let $index = index" class="customtab" [class.active]="JudgingForm?.SelectedTabIndex === $index" (click)="ChangeTab($index)">
                    <mat-icon *ngIf="(sec?.RubricQuestionsScored < sec?.RubricQuestions?.length)" class="redicon">report_problem</mat-icon>
                    <mat-icon *ngIf="(sec?.RubricQuestionsScored === sec?.RubricQuestions?.length)" class="greenicon">done</mat-icon>
                    <span>{{sec.Name}}</span>
                </div>
            </div>
            <h2>Nominee Responses</h2>
            <div *ngFor="let sec of JudgingForm?.Sections; let secIndex = index">
                <div *ngIf="JudgingForm?.SelectedTabIndex === secIndex">
                    <div *ngFor="let q of sec.Questions">
                        <h2 *ngIf="q.ShowNarrative">{{q.NarrativeText}}</h2>
                        <div>
                            <span *ngIf="q.ShowNumber">{{q.QuestionNumber}}.</span>
                            <span>{{q.QuestionText}}</span>
                        </div>
                        <div class="mat-elevation-z5 response">
                            <span>{{q.Response}}</span>
                            <span *ngIf="q.OtherResponse != null">: {{q.OtherResponse}}</span>
                        </div>
                    </div>
                    <div class="boundary"></div>
                    <div>
                        <h2>Judging Rubric</h2>
                        <table formArrayName="RatingsList">
                            <tr *ngFor="let rubricQuestion of sec.RubricQuestions; let questionIndex = index;" [formGroupName]="GetRubricIndex(secIndex, questionIndex)">
                                <td fxFlex="75">{{rubricQuestion.QuestionText}}</td>
                                <td fxFlex>
                                    <mat-radio-group fxLayout="column" formControlName="Score">
                                        <mat-radio-button *ngFor="let rating of rubricQuestion.Ratings; let ratingIndex = index;" [value]="ratingIndex">{{rating.Text}}</mat-radio-button>
                                    </mat-radio-group>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="boundary"></div>
                </div>
            </div>
        </form>
    </div>
</div>

